/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteDTO
 */
export interface FavoriteDTO {
    /**
     * 
     * @type {number}
     * @memberof FavoriteDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FavoriteDTO
     */
    contentfulType: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteDTO
     */
    contentfulId: string;
    /**
     * 
     * @type {number}
     * @memberof FavoriteDTO
     */
    userId: number;
}

/**
 * Check if a given object implements the FavoriteDTO interface.
 */
export function instanceOfFavoriteDTO(value: object): value is FavoriteDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contentfulType' in value) || value['contentfulType'] === undefined) return false;
    if (!('contentfulId' in value) || value['contentfulId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function FavoriteDTOFromJSON(json: any): FavoriteDTO {
    return FavoriteDTOFromJSONTyped(json, false);
}

export function FavoriteDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contentfulType': json['contentfulType'],
        'contentfulId': json['contentfulId'],
        'userId': json['userId'],
    };
}

export function FavoriteDTOToJSON(json: any): FavoriteDTO {
    return FavoriteDTOToJSONTyped(json, false);
}

export function FavoriteDTOToJSONTyped(value?: FavoriteDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contentfulType': value['contentfulType'],
        'contentfulId': value['contentfulId'],
        'userId': value['userId'],
    };
}

